// Utility functions for email handling

/**
 * Safely encode a string to base64, handling non-Latin1 characters
 */
export function safeBase64Encode(str: string): string {
  // Use TextEncoder to handle UTF-8 encoding
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  
  // Convert to base64 using browser's btoa
  let base64 = '';
  const bytes = new Uint8Array(data);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    base64 += String.fromCharCode(bytes[i]);
  }
  return btoa(base64);
}

/**
 * Format email content with proper MIME headers and encoding
 */
export function formatEmailContent({
  from,
  to,
  cc,
  bcc,
  subject,
  body,
  signature
}: {
  from: string;
  to: string | string[];
  cc?: string[];
  bcc?: string[];
  subject: string;
  body: string;
  signature?: string;
}): string {
  const toAddresses = Array.isArray(to) ? to.join(', ') : to;
  
  const headers = [
    'MIME-Version: 1.0',
    'Content-Type: text/html; charset=utf-8',
    `From: ${from}`,
    `To: ${toAddresses}`,
    ...(cc?.length ? [`Cc: ${cc.join(', ')}`] : []),
    ...(bcc?.length ? [`Bcc: ${bcc.join(', ')}`] : []),
    `Subject: ${subject}`,
    ''
  ];

  const content = body + (signature ? `<br/><br/>${signature}` : '');

  return headers.join('\r\n') + '\r\n' + content;
}